//
// products-service.js
//
// Copyright (c) 2015 by Curalate, Inc.
//
/* global angular:false */
((() => {
    const factories = angular.module('curalate');

    factories.factory('ProductsService', ['$http', '$q', 'PromiseService', ($http, $q, PromiseService) => {
        const BASE_URL = '/api/products';

        return {
            getCatalogsByClientId(clientId) {
                return PromiseService.processHttpResponse($http({
                    method: 'GET',
                    url: `${BASE_URL}/client/${clientId}/catalogs`,
                }));
            },
            getCatalogById(catalogId) {
                return PromiseService.processHttpResponse($http({
                    method: 'GET',
                    url: `${BASE_URL}/catalogs/${catalogId}`
                }))
            },
            getSample(catalogId) {
                return PromiseService.processHttpResponse($http({
                    method: 'GET',
                    url: `${BASE_URL}/catalog/${catalogId}/sample`,
                }));
            },
        };
    },
    ]);
}))();
